import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { RSF, RSFAmendment, RSFButtonAction, } from '../rsf';
import { RSFPrivileges, RSFStatus } from '../rsf.service';
import { RsfSettingsComponent } from '../rsf-settings/rsf-settings.component';
import { FormHistoryButtonComponent } from 'src/app/controls/form-history/form-history-button/form-history-button.component';
import { Router } from '@angular/router';
import { RsfHoldPointDashboardService } from '../rsf-hold-point-dashboard/rsf-hold-point-dashboard.service';

@Component({
  selector: 'rsf-buttons',
  templateUrl: './rsf-buttons.component.html',
  styleUrls: ['./rsf-buttons.component.scss']
})
export class RsfButtonsComponent extends BaseComponent {

  @Input() rsf?: RSF | null;
  @Input() rsfAmendment?: RSFAmendment | null;
  @Input() privileges?: RSFPrivileges;
  @Input() status?: RSFStatus;
  @Output() clicked = new EventEmitter<RSFButtonAction>();

  @ViewChild(FormHistoryButtonComponent) showHistory?: FormHistoryButtonComponent;

  action = RSFButtonAction;

  canReleaseEditingForm(): boolean {
    const isReleaseStatus =
      this.rsf?.status === this.formStatusEnum.Draft ||
      this.rsf?.status === this.formStatusEnum.AmendmentDrafting;
    const isCurrentEditor =
      this.rsf?.editingBy?.id == this.currentUser?.id ||
      this.rsfAmendment?.editingBy?.id == this.currentUser?.id;

    return !!(
      isReleaseStatus &&
      (this.rsf?.editingBy || this.rsfAmendment?.editingBy) &&
      (this.privileges?.canRelease || isCurrentEditor)
    );
  }

  /**
   * Opens the RSF hold-point matrix and preserves the currently selected RSF for row positioning.
   * Navigation is handled by the Angular router.
   */
  openHoldPointDashboard(): void {
    // Preserve the current RSF selection in shared state so it does not appear in the URL.
    this.injector.get(RsfHoldPointDashboardService).setSelectedSerialNo(this.rsf?.serialNo);
    this.injector.get(Router).navigate(['/rsf-hold-points']);
  }

  async settings() {
    if (await this.canDeactivate()) {
      const confirm = this.dialog.open(RsfSettingsComponent, {
        width: "60vw",
        height: "80vh"
        // data: confirmMessage,
      });
      return new Promise(resolve => {
        confirm.afterClosed().subscribe(data => resolve(!!data));
      });
    }
    return null;
  }
}
